const WHATSAPP_NUMBER = "918377982191";

const formatPrice = (price) => (price > 0 ? `Rs. ${price} per plate` : "Not available");

export const buildBanquetWhatsappMessage = ({
  banquet,
  selectedDate,
  selectedSlot,
  pageUrl,
}) => {
  const lines = [
    "Hello DecorZoom, I am interested in this banquet.",
    "",
    `Banquet Name: ${banquet.name}`,
    `Location: ${banquet.locality}, ${banquet.city}`,
    `Guests: ${banquet.guestMin} - ${banquet.guestMax}`,
    `Veg Price: ${formatPrice(banquet.vegPrice)}`,
    `Non Veg Price: ${formatPrice(banquet.nonVegPrice)}`,
    `Google Rating: ${banquet.googleRating} (${banquet.googleRatingsTotal} ratings)`,
  ];

  if (selectedDate) {
    lines.push(`Preferred Date: ${selectedDate}`);
  }

  if (selectedSlot) {
    lines.push(`Preferred Slot: ${selectedSlot}`);
  }

  if (pageUrl) {
    lines.push(`Page URL: ${pageUrl}`);
  }

  lines.push("", "Please share availability and decor options.");

  return lines.join("\n");
};

export const buildBanquetWhatsappLink = (context) => {
  const message = buildBanquetWhatsappMessage(context);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

export const buildFoodTastingWhatsappLink = ({ banquet }) => {
  const message = `Hi, I'd like to book a visit and food tasting for ${banquet.name}. Please share available slots.`;
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
};

export { WHATSAPP_NUMBER };
